<div class="header-wrapper">
  <div class="header-navigation">
    <div class="nav-list">

      <ul class="nav-list-ul">
        <li><a routerLink="/" routerLinkActive="active">
          <mat-icon class="link-icon">dashboard</mat-icon>
          <span>Dashboard</span>
        </a></li>
        <li
          class="cash-withdrawal"><a routerLink="./payouts" routerLinkActive="active">
          <mat-icon class="link-icon">payments</mat-icon>
          <span>Withdraws</span>
        </a></li>
        <li
            class="cash-withdrawal"><a routerLink="./payouts-by-skins" routerLinkActive="active">
          <mat-icon class="link-icon">toys</mat-icon>
          <span>Market</span>
        </a></li>
        <li *ngIf="canAccessVip"><a routerLink="./vip-stats" routerLinkActive="active">
          <mat-icon class="link-icon">star</mat-icon>
          <span>VIP</span>
        </a></li>
      </ul>

    </div>
  </div>
  <div class="header-user-search">
    <form class="search-select-block" [formGroup]="searchForm">
      <input formControlName="inputQuery" class="search" type="text" placeholder="Seach"
             (keypress)="checkValue($event)"
             (keydown.enter)="onEnter(search)"
             #search>
      <ng-container *ngIf="searchResult.length || loading">
        <ul class="search-result">
          <div class="loading-overlay" *ngIf="loading">
            <mat-spinner [diameter]="25"></mat-spinner>
          </div>
          <ng-container *ngIf="!loading">
            <li *ngFor="let user of searchResult | slice:0:3">
              <img src="{{user.avatar}}">
              <a [routerLink]="['/user', user.id]" (click)="clearInput(); search.value=''">{{user.name}}</a>
            </li>

            <li *ngIf="searchResult.length>5"><a [routerLink]="['/user/find']" (click)="search.value=''; searchResult=[]">Показать все
              результаты</a></li>
          </ng-container>
        </ul>
      </ng-container>
      <mat-select formControlName="searchType" class="select-criteria">
        <mat-option *ngFor="let type of searchType" [value]="type.value">
          {{type.viewValue}}
        </mat-option>
      </mat-select>
    </form>
  </div>
  <app-profile (click)="toggleNavigator()"></app-profile>
  <app-navigator
    [opened]="navigatorIsOpened"
    [ngClass]="{ 'opened': navigatorIsOpened }"
    (changeOpened)="navigatorEvent($event)"
  ></app-navigator>
</div>
